import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getServiceConfig = params => common.requestRaw(apiUrl + 'ServiceConfig', params, 'get');
export const getConnLDAP = params => common.requestRaw(apiUrl + 'Ldap', params, 'get');
export const updateServiceConfig = params => common.requestRaw(apiUrl + 'ServiceConfig', params, 'put');
export const checkSmtp = params => common.requestRaw(execUrl + 'CheckSmtp', params, 'get');
export const targetSync = params => common.requestRaw(apiUrl + 'Sync', params, 'post');

export function ServiceConfigInitSmtp(params) {
  return axios({
    method: 'put',
    url: execUrl + 'ServiceConfigInit',
    params: { category: 'smtp' }
  });
}



// WEBPACK FOOTER //
// ./src/script/libs/configLib.js